module.exports = __webpack_public_path__ + "img/Réalisation structure métallique pour hamac dans mezzanine.4735af58.jpg";